import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Card, Button, Form, Input } from "antd";
import React, { useState, useEffect } from "react";
import { addTranslations } from "../../../utils/functions/javaScriptHelper";
import GalkButton from "../../common/component/button";
import { EditPenOnPaperRightHandIcon, RefreshIcon } from "../../common/icons";
import "./style.css";

import { usePreviousState } from "../../../utils/customHooks";
import { updateCompanyBasicInformation } from "../../../actions/companyActions";

const OperationalInformation = ({
	companyBasicDetails,
	isActionProgress,
	updateCompanyBasicInformation,
	setCompletionBool,
}) => {
	const [form] = Form.useForm();
	const prevActionInProgressValue = usePreviousState(isActionProgress);
	const [isEditable, setIsEditable] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		if (!isActionProgress && prevActionInProgressValue) {
			setIsEditable(false);
		}
	}, [isActionProgress]); // eslint-disable-line react-hooks/exhaustive-deps

	const resetAll = () => {
		form.resetFields();
		setIsEditable(false);
	};

	const updateInformation = async (values) => {
		let updatedValue = {
			description: values.description || "",
		};

		let updatedValueWithTranslations = {
			...(await addTranslations(updatedValue, ["description"])),
		};

		updateCompanyBasicInformation(updatedValueWithTranslations);
		setCompletionBool("operationalInfo");
	};
	return (
		<Card
			type="inner"
			title={t("accountSetting_operationalInfo_sectionHeading")}
			extra={
				isEditable ? (
					<div style={{ display: "flex", gap: "16px" }}>
						<GalkButton
							type="secondary"
							height={36}
							additionalStyle={{ padding: "13px 16px" }}
							onClick={resetAll}
							disabled={isActionProgress}
							style={{ marginRight: 10 }}
						>
							{t("editProject_modalAction_cancel")}
						</GalkButton>
						<GalkButton
							type="primary"
							height={36}
							additionalStyle={{ padding: "13px 16px" }}
							onClick={() => form.submit()}
							disabled={false}
							loading={isActionProgress}
						>
							<RefreshIcon width={14} height={14} />
							{t("editProject_modalAction_submit")}
						</GalkButton>
					</div>
				) : (
					<GalkButton
						type="default"
						height={36}
						additionalStyle={{ padding: "13px 16px" }}
						onClick={() => setIsEditable(true)}
					>
						<EditPenOnPaperRightHandIcon width={14} height={14} />
						{`${t("edit")}`}
					</GalkButton>
				)
			}
		>
			{Object.entries(companyBasicDetails).length > 0 && (
				<Form
					layout="vertical"
					form={form}
					initialValues={
						companyBasicDetails && {
							description: companyBasicDetails.description,
						}
					}
					onFinish={updateInformation}
					className="operationalInfo_form"
				>
					<Form.Item
						label={
							<div>
								<div className="operationalInfo_formLabel">
									{t("accountSetting_operationalInfo_title")}:
								</div>
								<div>
									<div className="operationalInfo_formLabel_helpText">
										1. {t("accountSetting_operationalInfo_instruction1")}.
									</div>
									<div className="operationalInfo_formLabel_helpText">
										2. {t("accountSetting_operationalInfo_instruction2")}.
									</div>
									<div className="operationalInfo_formLabel_helpText">
										3. {t("accountSetting_operationalInfo_instruction3")}.
									</div>
								</div>
							</div>
						}
						name="description"
						rules={[
							{
								required: true,
								message: t("provide_required_information"),
							},
						]}
					>
						<Input.TextArea
							placeholder="Please fill in company introduction."
							disabled={!isEditable}
							autoSize={{ minRows: 6, maxRows: 10 }}
						/>
					</Form.Item>
				</Form>
			)}
		</Card>
	);
};
const mapStateToProps = (state) => ({
	companyBasicDetails: state.company.company,
	isActionProgress: state.company.actionInProgress,
});

export default connect(mapStateToProps, { updateCompanyBasicInformation })(
	OperationalInformation
);
